import React, { useEffect, useRef, useState } from 'react';

const Popup = ({ showPopUpDiv, setShowPopUpDiv, htmlMsg }) => {
    const [showPopup, setShowPopup] = useState(true);
    const wrapperRef = useRef(null);

    const handleClosePopup = () => {
        setShowPopup(false);
        setShowPopUpDiv(false);
    };

    useEffect(() => {
        // Function to handle clicks outside of the div
        const handleClickOutside = (event) => {
            if (wrapperRef.current) {
                handleClosePopup();
            }
        };

        // Bind the event listener
        document.addEventListener('mousedown', handleClickOutside);

        // Cleanup the event listener on unmount
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <>
            {showPopup && (
                <div id="nsd_sales_pop_up" ref={wrapperRef}>
                    <div className='sales_pop_up'
                    >
                        <span className="cancel-icon" onClick={handleClosePopup}>
                            &times;
                        </span>
                        <br />
                        <div className="display-text-pop-up"
                        >
                            <span>
                                <span dangerouslySetInnerHTML={{ __html: htmlMsg }} /> <br />
                            </span>
                        </div>
                        <br />
                        <br />
                    </div>
                </div>
            )}
            <div id="nsd_sales_pop_disp_popup"></div>
        </>
    );
};

export default Popup;
